﻿import { ajaxPost } from '../../utils/ajax';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'di-documents-b2c',
    props: ['blockid', 'viewmodel'],
    created() {
    },
    mounted() {
        this.model = this.viewmodel;
        this.$store.dispatch('setDeliveryAddress', { 'deliveryAddress': this.model.deliveryAddress });
        this.$store.watch(state => state.digitalvalidation.pageLoader.showLoader,
            (newState) => {
                this.showLoader = newState;
            });
        this.$store.watch(state => state.digitalvalidation.alertModal.show,
            (newState) => {
                if (newState === true) {
                    this.showPopUp = true;
                    this.$store.dispatch('hideModal');
                }
            });
    },
    computed:
    {
        approveAll: {
            get: function () {
                if (this.viewmodel.displayNumberPorting) {
                    return this.approved.length == 3;
                } else {
                    return this.approved.length == 2;
                }
            }
        },
        notAllApproved: {
            get: function () {
                return !this.approveAll;
            }
        }
    },
    data: () => ({
        model: {

        },
        approved: [],
        showLoader: false,
        showPopUp: false
    }),
    methods: {
        executeSigning: function (orderId, dealerCode, channelType, data) {
            var errorMessages = {
                "signContractsErrorMessage": this.model.currentBlock.signErrorMessage,
                "approveOrderGeneralErrorMessage": this.model.currentBlock.approveErrorMessage,
                "approveOrderMissingDownPaymentPlanErrorMessage": this.model.currentBlock.approveOrderMissingDownPaymentPlanErrorMessage,
                "approveOrderCAValidationErrorMessage": this.model.currentBlock.approveOrderCAValidationErrorMessage,
            };

            this.$store.dispatch('signDocumentsBtC',
                {
                    'data': data,
                    'loaderTitle': this.model.currentBlock.loaderTitle,
                    'loaderMessage': this.model.currentBlock.loaderMessage,
                    'orderId': orderId,
                    'dealerCode': dealerCode,
                    'channelType': channelType,
                    'errorMessages': errorMessages
                });
        },
        getDocumentsPdf: function (event, orderId, dealerCode, channelType, teliaFinanceContracts, fileName, loaderTitle, loaderMessage, popupMessage) {
            event.preventDefault();

            this.$store.dispatch('getDocumentsPdf',
                {
                    'orderId': orderId,
                    'dealerCode': dealerCode,
                    'channelType': channelType,
                    'teliaFinanceContracts': teliaFinanceContracts,
                    'fileName': fileName,
                    'loaderTitle': loaderTitle,
                    'loaderMessage': loaderMessage,
                    'popupMessage': popupMessage
                });
        },
        closePopup: function () {
            this.showPopUp = false;
        },
        payNow() {
            var orderId = this.model.orderId;
            var returnUrl = encodeURIComponent(this.model.creditCardPaymentRedirectUrl);

            this.$store.dispatch('creditCardPayInitialize',
                {
                    'orderId': orderId,
                    'returnUrl': returnUrl,
                    'loaderTitle': this.model.currentBlock.loaderTitle,
                    'loaderMessage': this.model.currentBlock.loaderMessage,
                    'errorMessage': this.model.currentBlock.initPaymentErrorMessage
                });
        },
        redirectToNetaxept() {
            var redirectUrl = encodeURIComponent(this.model.netaxeptUrl);

            this.$store.dispatch('redirectToNetaxeptTerminal',
                {
                    'redirectUrl': redirectUrl,
                    'loaderTitle': this.model.currentBlock.loaderTitle,
                    'loaderMessage': this.model.currentBlock.loaderMessage
                });
        }
    },
    ready: function () {
    }
}